import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const PUB = process.env.PUBLIC_URL || "";
const PLAYLIST = [
  `${PUB}/rheinstrass.mp3`,
  `${PUB}/rheinstrass-kein-zentrum-v1.mp3`,
  `${PUB}/rheinstrass-kein-zentrum-v2.mp3`,
  `${PUB}/rheinstrass-kein-zentrum-v3.mp3`,
  `${PUB}/rheinstrass-fluss.mp3`,
];
const KEY = "rs5_music_on";

const randomIndex = (exclude = -1) => {
  if (PLAYLIST.length <= 1) return 0;
  let i = Math.floor(Math.random() * PLAYLIST.length);
  if (i === exclude) i = (i + 1) % PLAYLIST.length;
  return i;
};

// App-Hintergrundmusik: spielt die Songs in zufälliger Reihenfolge, per Button stummschaltbar.
export const MusicPlayer = () => {
  const audioRef = useRef(null);
  const idxRef = useRef(randomIndex());
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const el = audioRef.current;
    if (!el) return;
    el.volume = 0.3;
    el.src = PLAYLIST[idxRef.current];
    const wantOn = localStorage.getItem(KEY) !== "off"; // Standard: an

    const tryPlay = () =>
      el.play().then(() => setPlaying(true)).catch(() => setPlaying(false));

    if (wantOn) {
      tryPlay();
      const onGesture = () => {
        if (localStorage.getItem(KEY) !== "off" && el.paused) tryPlay();
        window.removeEventListener("pointerdown", onGesture);
      };
      window.addEventListener("pointerdown", onGesture, { once: true });
      return () => window.removeEventListener("pointerdown", onGesture);
    }
  }, []);

  // Nächster zufälliger Song, wenn einer zu Ende ist
  const handleEnded = () => {
    const el = audioRef.current;
    if (!el) return;
    idxRef.current = randomIndex(idxRef.current);
    el.src = PLAYLIST[idxRef.current];
    el.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
  };

  const toggle = () => {
    const el = audioRef.current;
    if (!el) return;
    if (el.paused) {
      el.play().then(() => setPlaying(true)).catch(() => {});
      localStorage.setItem(KEY, "on");
    } else {
      el.pause();
      setPlaying(false);
      localStorage.setItem(KEY, "off");
    }
  };

  return (
    <>
      <audio ref={audioRef} onEnded={handleEnded} preload="auto" data-testid="app-music-audio" />
      <button
        onClick={toggle}
        data-testid="music-toggle-btn"
        aria-label={playing ? "Musik aus" : "Musik an"}
        title={playing ? "Musik aus" : "Musik an"}
        className={`fixed right-4 bottom-20 z-40 h-11 w-11 rounded-full flex items-center justify-center shadow-lg border transition-colors ${
          playing
            ? "bg-amber-500 border-amber-300 text-black"
            : "bg-[#12090c]/90 border-white/20 text-rose-100/70 backdrop-blur-xl"
        }`}
      >
        {playing ? <Volume2 size={20} /> : <VolumeX size={20} />}
      </button>
    </>
  );
};
